import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import MovingPrice from '../../../components/v2/MovingPrice'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import TplProgressbar from '../../../components/v2/progrees-bars/TplProgressbar'
import { useAppDispatch, useAppSelector } from '../../../store'
import { TplState, setForWho } from '../../../store/tplSlice'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import { Helmet } from 'react-helmet-async'
import { AppState } from '../../../store/appSlice'

const InsuranceFor = () => {
  //
  const { t } = useTranslation()
  //
  const dispatch = useAppDispatch()
  //
  const navigate = useNavigate()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { data: insureChoice, isLoading: isInsureChoiceLoading } = api.useGetTplInsureChoiceQuery(undefined)
  //
  const { checkout, filter, screenHeader } = useAppSelector((data: { tpl: TplState }) => data.tpl)
  //
  const pageTitle = insureChoice?.translations[lang]?.title
  const stepName = insureChoice?.translations[lang]?.stepName
  //
  //
  // auto navigate first page
  useEffect(() => {
    if (!filter.dates?.start) {
      navigate('/tpl-choose-days')
    }
    //
    return () => {}
  }, [filter.dates?.start, navigate])
  //
  //
  const mainLoading = isInsureChoiceLoading
  //
  //
  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageTitle} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

      <Content>
        <Title text={pageTitle} />

        <TplProgressbar stepName={stepName} />

        <MovingPrice price={filter.offerTotalPrice} currency={filter.currency} />

        <Cards>
          {insureChoice &&
            insureChoice?.listItems?.map((item, index) => {
              return (
                <HorizontalCard
                  className="horizontal-card"
                  key={index}
                  disabled={false}
                  title={item?.title}
                  description={item?.body}
                  imgUrl={item?.image}
                  selected={item.type === checkout.forWho ? true : false}
                  onClick={() => {
                    dispatch(setForWho(item.type))
                  }}
                />
              )
            })}
        </Cards>

        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => {
              if (filter.chooseMethod === 'frani-choice') {
                return navigate('/tpl-offer')
              }
              //
              if (filter.chooseMethod === 'my-choice') {
                return navigate('/tpl-offer')
              }
              //
              return navigate('/tpl-offer')
              //
            }}
          />

          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={checkout && checkout.forWho && checkout.forWho.length >= 1 ? false : true}
            onClick={() => {
              if (filter.chooseMethod === 'frani-choice') {
                return navigate(
                  checkout.forWho === 'for-me'
                    ? '/tpl-for-me'
                    : checkout.forWho === 'for-other'
                    ? '/tpl-for-other'
                    : '',
                )
              }
              //change filter.chooseMethod === 'my-choice')
              if (filter.chooseMethod === 'my-choice') {
                return navigate(
                  checkout.forWho === 'for-me'
                    ? '/tpl-for-me'
                    : checkout.forWho === 'for-other'
                    ? '/tpl-for-other'
                    : '',
                )
              }
            }}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Cards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 32px;

  .horizontal-card {
    &:first-child {
      margin-bottom: 24px;
    }
  }

  ${Responsive.mobile} {
    margin-top: 24px;

    .horizontal-card {
      margin-bottom: 20px;
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`
export default InsuranceFor
